export default "__VITE_ASSET__CPXjo2RM__"